import {gql} from '@apollo/client';

export const INSTALLED_EXTENSION_DEFINITIONS_QUERY = gql`
  query InstalledExtensionDefinitionsQuery($extensionType: ExtensionType!)
  @skipAudit
  @engComponent(name: EXTENSIONS) {
    installedExtensionDefinitions(extensionType: $extensionType) {
      items {
        id
        installationId
        installApprovalRequired
        installApprovalText
        name
        isOwnedByBenchling
        tags
        tagLine
        description
        extensionType
        createdAt
        modifiedAt
        provider {
          name
          url
        }
        links {
          documentation {
            url
            text
          }
          policy {
            url
            text
          }
        }
        latestVersion {
          id
          versionId
          description
          mcpProperties {
            serverUrl
            urlParams {
              key
              label
              description
              options
            }
          }
        }
        labels {
          key
          value
          displayName
        }
      }
    }
    extensionLabelSpecs(extensionType: $extensionType) {
      key
      displayName
      placement
    }
  }
`;
